import { Edit3, Power } from 'lucide-react';

import InputIconByKey from '../../../../components/Forms/Input/InputIconByKey';
import { IconKey } from '../../../../types/system/icons';
import { RestaurantRawMaterialCategoryDTO } from '../../../../types/restaurant/RestaurantRawMaterialCategoryTypes';

interface RawMaterialCategoryCardProps {
  category: RestaurantRawMaterialCategoryDTO;
  onEdit: (category: RestaurantRawMaterialCategoryDTO) => void;
  onToggleActive: (category: RestaurantRawMaterialCategoryDTO) => void;
}

const RawMaterialCategoryCard = ({
  category,
  onEdit,
  onToggleActive,
}: RawMaterialCategoryCardProps) => {
  const color = category.color || '#10B981';

  return (
    <article
      className={`rounded-xl border border-stroke bg-white p-5 transition hover:border-primary/30 hover:shadow-default dark:border-strokedark dark:bg-boxdark ${
        category.active ? '' : 'opacity-60'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 gap-3">
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border"
            style={{
              backgroundColor: `${color}1a`,
              borderColor: `${color}40`,
              color,
            }}
          >
            <InputIconByKey
              iconKey={(category.icon as IconKey) || 'box'}
              className="h-5 w-5"
            />
          </span>

          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-bodydark2">
              {category.code}
            </p>

            <h3 className="mt-1 truncate font-semibold text-black dark:text-white">
              {category.name}
            </h3>
          </div>
        </div>

        <span
          className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-medium ${
            category.active
              ? 'bg-success/10 text-success'
              : 'bg-danger/10 text-danger'
          }`}
        >
          {category.active ? 'Activa' : 'Inactiva'}
        </span>
      </div>

      <p className="mt-5 min-h-[42px] text-sm text-bodydark2 dark:text-bodydark">
        {category.description || 'Sin descripción.'}
      </p>

      <p className="mt-2 text-xs text-bodydark2">
        Orden #{category.displayOrder}
      </p>

      <div className="mt-4 flex gap-2 border-t border-stroke pt-4 dark:border-strokedark">
        <button
          type="button"
          onClick={() => onEdit(category)}
          className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-stroke py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
        >
          <Edit3 className="h-4 w-4" />
          Editar
        </button>

        <button
          type="button"
          title={category.active ? 'Desactivar' : 'Activar'}
          onClick={() => onToggleActive(category)}
          className={`rounded-xl border px-3 py-2 transition ${
            category.active
              ? 'border-danger/30 bg-danger/5 text-danger hover:bg-danger hover:text-white'
              : 'border-primary/30 bg-primary/5 text-primary hover:bg-primary hover:text-white'
          }`}
        >
          <Power className="h-4 w-4" />
        </button>
      </div>
    </article>
  );
};

export default RawMaterialCategoryCard;
